// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: #272626;
  font-family: poppins !important;
}

:root {
  --primary: #edf9fe;
  --secondary: #f57c21;
  --tertiary: #efd623;
  --outline: #e4e6ea;
  --light: #f8f8f8;
  --dark: #62666b;
}

/**** Resets *****/

/** login Form **/

body {
  width: 100%;
  height: 100%;
  font-family: Poppins, sans-serif !important;
}

.back-secondary {
  background-color: var(--secondary) !important;
}

::-webkit-scrollbar {
  width: 7px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: var(--dark);
  border-radius: 10px;
}

.edit-btn-modal {
  border: 1px solid var(--secondary) !important;
  margin-inline: 10px;
  transition: 0.4s !important;
  margin: 0;
  padding-block: 2px !important;
  color: var(--secondary) !important;
  padding-inline: 20px !important;
}

.edit-btn-modal:hover {
  border: 1px solid var(--tertiary) !important;
  color: var(--tertiary) !important;
}

.card-btn {
  background-color: #212529 !important;
  margin-inline: 10px;
  transition: 0.4s !important;
  margin: 0;
  color: white !important;
}

.card-btn:hover {
  scale: 1.02;
  transition: 0.4s;
}

.primary-btn {
  background-color: var(--secondary) !important;
  margin-inline: 10px;
  transition: 0.4s !important;
  margin: 0;
  color: white !important;
}

.text-small {
  font-size: 12px !important;
}

.clr-secondary {
  color: var(--secondary) !important;
}

.primary-btn:hover {
  background-color: var(--tertiary) !important;
  scale: 1.02;
  color: #4a4a4a !important;
  transition: 0.4s;
}

.img404 {
  width: 200px;
  margin-block: 50px;
}

.pointer {
  cursor: pointer;
}

.dark-btn {
  background-color: var(--dark) !important;
  margin-right: 10px !important;
  transition: 0.4s !important;
  margin: 0;
  color: var(--light) !important;
  font-size: 12px !important;
}

.dark-btn:hover {
  background-color: var(--dark) !important;
  scale: 1.02;
  transition: 0.4s;
}

.chart-btn {
  background-color: transparent;
  border: 0;
  color: #656a72 !important;
  font-size: 12px !important;
  margin-right: 10px;
}

.parent-loader {
  position: relative;
  min-height: 100px;
}

.parent-loader-label {
  position: relative;
  width: 12px;
  height: 12px;
  display: inline-block;
}

.parent-loader-label .spinner-border {
  font-size: 10px;
  width: 100%;
  height: 100%;
}

.parent-loader-btn .loading {
  background-color: transparent;
}

.parent-loader-btn {
  position: relative;
  width: 12px;
  height: 12px;
  display: inline-block;
}

.parent-loader-btn .spinner-border {
  font-size: 10px;
  width: 100%;
  height: 100%;
  color: white;
}

.table-parant-loader {
  position: relative;
  height: 100px !important;
}

.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: white;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
}

input.login_input {
  display: block;
  width: 100%;
  padding: 1.3em 2em;
  font-size: 14px;
  background-color: #eee;
  border: 0px solid transparent;
  border-radius: 12px;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

button.login_button {
  display: block;
  width: 100%;
  border: 0px solid transparent;
  background-color: rgb(255, 61, 61);
  color: #fff;
  padding: 1.5em 0em;
  border-radius: 12px !important;
  font-weight: 600;
  margin-bottom: 2em;
  cursor: pointer;
}

button.login_button:hover {
  background-color: rgba(255, 61, 61, 0.804);
}

.input {
  margin-bottom: 2em;
  position: relative;
}

.eye_icon {
  position: absolute;
  top: 40%;
  right: 2%;
}

.eye_icon:hover {
  cursor: pointer;
}

.login_screen label {
  font-size: 0.9rem;
}

section.login_screen {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(90deg, #000000e0 50%, #fff 50%);
}

div.bg_img {
  width: 100%;
}

h6.registration {
  margin-top: 1.5em;
}

span.not_registered {
  color: orangered;
}

img.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  z-index: 10;
  object-fit: cover;
}

.missing_field {
  padding: 0.5em 0;
  font-size: 12px;
  color: red;
}

a.forget_link {
  text-decoration: none;
  color: #000;
  font-size: 1rem;
  font-weight: 400;
}

/*********************** Sidebar Styles  ************************/

div.avatar_wrapper {
  position: relative !important;
}

.avatar_img {
  width: 40px;
  height: 40px;
  border-radius: 100%;
}

.avatar_status {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  position: absolute;
  right: 0;
  background-color: green;
}

a.side_bar_link {
  text-decoration: none;
  color: #000 !important;
  padding-left: 1.5em;
}

/***** header ******/

.header {
  background-color: var(--secondary);
  padding-block: 10px;
  padding-inline: 20px;
  display: flex;
  justify-content: space-between;
}

.header a {
  color: white;
  text-decoration: none;
  margin-block: auto;
  font-size: 1rem;
}

/* Order table css */
/* p {
  margin-bottom: 0 !important;
} */

/* @media (min-width: 348px) and (max-width: 768px) {
    .header {
        flex: 1;
    }
} */

/** utilities **/

/* Media query to prevent table overflow */

/* Media query to prevent table overflow */

.table_section {
  width: 100% !important;
  height: auto !important;
  padding-left: 18%;
}

.top-chart-bar > div > div {
  margin-block: auto;
}

.top-chart-bar p {
  margin: 0;
  font-weight: 700;
  font-size: 1rem;
}

.top-chart-bar span {
  margin: 0;
  font-weight: 600;
  font-size: 1rem;
  color: var(--secondary);
}

.top-chartbar-chart {
  padding-inline: 20px;
  margin-block: auto;
  width: 100%;
}

.heading {
  font-size: 25px;
  color: #4a4a4a;
  font-weight: 500;
}

.heading-m {
  font-size: 20px;
  font-weight: 500;
  color: #4a4a4a;
}

.wrapper {
  flex: 1 0 auto;
  padding: 1.5rem;
}

.show-canvas {
  display: block;
  width: 300px;
  position: absolute;
  background-color: #fff;
  transition: width 0.5s linear all;
}

.off-canvas {
  display: block;
  z-index: 10;
  /* transition: width 0.5s ease-in-out, opacity 0.5s ease-in-out; */
}

/***** Order  *****/

ul.nav li.nav-item a {
  color: #585858;
}

.entries {
  font-size: 14px;
}

.table_section {
  height: 90vh;
  width: 100%;
}

.table_overflow {
  border-collapse: collapse;
  max-width: 100%;
  white-space: nowrap;
  width: 100%;
}

.custome-table {
  width: max-content !important;
  min-width: 100%;
}

table td:hover {
  background-color: #eeee;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

table.table-tb th.tr-tt {
  background-color: #e9eef9 !important;
}
table.table-tb th {
  background-color: #fff !important;
}

table.table-tb td {
  /* background-color: #fff !important; */
  border-right: none;
}

table th {
  background-color: #ccc !important;
  color: #000 !important;
  font-size: 14px;
  text-transform: capitalize;
  font-weight: 300;
}

table td {
  font-size: 15px;
  border-right: 1px solid #62666b3d;
  padding-right: 50px !important;
}

.results {
  font-weight: 500;
}

.order_input {
  padding: 0.3em 0.5em;
  border: 1px solid #8080804a;
  font-size: 14px;
}

.order-wrapper {
  width: 50%;
}

th.narrow-col {
  width: 100px;
}

.table_more {
  width: 20px;
}

.pagination button {
  background-color: #fff;
  color: rgb(0, 0, 0) !important;
  border: 0;
  margin-inline: 5px;
  /* padding-inline: 5px; */
  width: 30px;
  text-align: center;
  padding-block: 3px;
}

.pagination button i {
  color: rgb(255, 255, 255) !important;
}

.page-item button {
  background-color: var(--secondary) !important;
}

.page-active button {
  background-color: var(--secondary) !important;
  color: #fff !important;
}

.page-active-btn button {
  background-color: var(--tertiary);
  color: #4a4a4a;
}

.para {
  font-size: 14px;
}

.para-m {
  font-size: 12px;
}

.progress-h {
  height: 8px !important;
  --bs-progress-height: 8px !important;
}

@media (min-width: 320px) and (max-width: 768px) {
  .order-wrapper {
    width: 100%;
  }

  .inputs_wrapper {
    flex-direction: column;
  }
}

li:has(.active_link.active) {
  background-color: var(--secondary) !important;
}

.active_link.active {
  color: white;
}

.main-content {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.logo {
  width: 100%;
  margin-inline: auto;
}

.login_logo {
  width: 200px;
}

.sidebar ul li {
  list-style: none;
  margin-block: 7px;
  padding-inline: 20px;
  transition: 0.3s;
}

.sidebar ul li:hover {
  background-color: var(--secondary);
  transition: 0.3s;
}

.sidebar ul li:hover a {
  color: white !important;
  transition: 0.3s;
}

.sidebar ul li a {
  color: #4a4a4a;
  text-decoration: none;
  display: inline-block;
  width: 100%;
  background-color: transparent;
  border: 0;
  text-align: start;
  font-size: 1.1rem;
  width: 100%;
  padding-block: 12px;
}

.sidebar ul {
  padding: 0;
}

.offcanva-custome {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border: 0 !important;
}

.footer {
  background-color: white;
  padding-block: 15px;
  text-align: center;
  flex-shrink: 0;
}

.card {
  border-radius: 5px !important;
  border: 1px solid #62666b1f !important;
}

.card-2 {
  box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.15);
}

.order-date {
  padding-right: 1rem;
  display: flex;
  margin-block: 5px;
  justify-content: end;
  align-items: center;
}

.table-header-item {
  align-items: center;
  justify-content: space-between;
}

.table-header-item > div {
  width: fit-content;
  /* justify-content: center; */
}

.table-action-dd {
  list-style: none;
  font-weight: 800;
}

.table-action-dd .dropdown-toggle::after {
  content: none !important;
}

.user_info {
  border-bottom: 2px solid #62666b1f !important;
  padding-block: 5px;
}

.user_info p {
  color: #000;
  font-size: 1.1rem;
  /* margin-top: 5px; */
  margin-bottom: 0;
}

.user_info label {
  font-weight: 500;
  font-size: 0.9rem;
  color: #62666b;
}

.coverage_info {
  border-bottom: 2px solid white !important;
  padding-block: 15px;
  display: flex;
  justify-content: space-between;
}

.coverage_info p {
  color: #000;
  font-size: 1.1rem;
  /* margin-top: 5px; */
  margin-bottom: 0;
}

.coverage_info label {
  font-weight: 500;
  font-size: 0.9rem;
  color: #62666b;
}

.coverage_info_img {
  position: absolute;
  top: -40px;
  width: 120px;
  right: 10px;
}

.coverage_info_img-2 {
  position: absolute;
  top: -40px;
  width: 80px;
  right: 10px;
}

.mt-10 {
  margin-top: 6rem !important;
}

.ac_info {
  margin-block: 15px;
  background-color: var(--light);
  padding: 10px;
  border-radius: 10px !important;
  position: relative;
}

.ac_info label {
  font-weight: 200;
  font-size: 10px;
}

.ac_info input,
.ac_info p {
  background: transparent;
  padding: 0;
  font-weight: 500;
  border: 0;
  font-size: 14px;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 0;
}

.ac_info input:focus {
  border: 0;
  outline: 0;
}

.ac_info i {
  position: absolute;
  right: 14px;
  top: 16px;
}

.v-border {
  border: 1px solid #62666b1f;
  width: 1px !important;
  padding: 0 !important;
  margin: 0 !important;
}

.order_history_card {
  position: relative;
  border-radius: 5px !important;
  /* background: linear-gradient(90deg, rgb(15, 27, 63) 0px, rgb(25, 66, 129)); */
  background: linear-gradient(
    90deg,
    rgb(245 124 33) 0px,
    rgb(243 135 53 / 68%)
  );
  box-shadow: 0 10px 7px 0 rgba(0, 0, 0, 0.15);

  border: 0 !important;
}

.order_history_card li b,
.order_history_card li span {
  color: white;
}

.order_history_card ul {
  padding: 0;
  margin: 0;
  /* margin-top: 20px; */
}

.order_history_card ul li {
  font-size: 1.1rem;
  display: grid;
  grid-template-columns: repeat(2, 50%);
  padding-block: 10px;
}

.order_history_card ul li b {
  font-size: 12px;
}

.order_history_card ul li span {
  /* color: var(--dark); */
  text-transform: capitalize;
  font-size: 12px;
}

/* .order_history_card::after {
  border-radius: 20px 20px 0 0px;
  content: "";
  top: -2;
  position: absolute;
  height: 15px;
  width: 100%;
  background-color: var(--secondary);
} */
.top-line::after {
  border-radius: 20px 20px 0 0px;
  content: "";
  top: -2;
  position: absolute;
  height: 15px;
  width: 100%;
  background-color: var(--secondary);
}

.table-responsive {
  min-height: 200px;
}

.order_card .order_card_date {
  color: #a3a7ad;
  margin-top: 10px;
}

/* .order_card img {
  width: 80px;
  height: 50px;
  box-shadow: 0 0.3rem 0.3rem #00000057;
  object-fit: fill;
  margin-block: 10px;
  margin-right: 20px;
} */
.order_card img {
  width: 80px;
  height: 50px;
  box-shadow: 0 0.3rem 0.3rem #00000057;
  object-fit: fill;
  margin-top: -55px !important;
  margin-block: 10px;
  /* margin-right: 20px; */
}

.order_card img.verified {
  margin: 0 !important;
}

.order_card:hover img.verified {
  transform: rotate(0);
}

.order_card_parent > :nth-child(o) {
  background-color: #000;
}

/* .order_card {
  display: grid;
  grid-template-columns: repeat(2, auto);
  border-bottom: 2px solid var(--secondary);
  background-color: var(--light);
  border-radius: 5px;
  padding-inline: 15px;
  box-shadow: 0 0.1rem 0.4rem #00000033;
} */
.order_card:nth-child(1) p {
  margin-bottom: 5px;
  font-size: 14px;
  text-transform: capitalize;
}

.order_card div {
  /* margin-top: 5px; */
}

.order_card > div:nth-child(2) {
  text-align: right;
  margin-block: auto;
  font-weight: 500;
}

.order_card > div:nth-child(2) i::before {
  font-weight: 600 !important;
  font-size: 20px;
  margin-left: 10px;
}

.order_card > div:nth-child(2) small {
  font-size: 14px;
  color: var(--dark);
}

.slide-left {
  width: 0 !important;
}

.slide-left-active {
  transition: 2s !important;
  width: 100% !important;
}

.pkg-card {
  border: 0 !important;
  /* background: linear-gradient(90deg, rgb(15, 27, 63) 0px, rgb(25, 66, 129)); */
  background: linear-gradient(
    90deg,
    rgb(245 124 33) 0px,
    rgb(243 135 53 / 68%)
  );
}

.pkg-card p,
.pkg-card label {
  color: white;
}

.pkgslider div {
  height: 100%;
}

.min-vp-80 {
  min-height: 80%;
}

.trafficsource_chart {
  position: relative;
}

.trafficsource_chart::after {
  width: 64%;
  height: 64%;
  content: "";
  background-color: transparent;
  position: absolute;
  top: 18%;
  left: 18%;
  border-radius: 100%;
  border: 2px solid #e5e5e5;
}

.revenuechart {
  margin-top: 38%;
}

.w-fit-content {
  width: fit-content;
}

.metrics-bar-chart {
  text-align: end;
}

.progress-bar-vertical {
  width: 12px;
  min-height: 140px;
  margin-right: 8px;
  background: #d0cece;
  display: -webkit-flex;
  display: inline-block !important;
  align-items: flex-end;
  -webkit-align-items: flex-end;
  transform: rotate(180deg);
}

.progress-bar-vertical .progress-bar {
  width: 100%;
  height: 0;
  transition: height 0.6s ease;
  background-color: var(--secondary);
}

.gauge-metrics {
  max-width: 150px;
  position: absolute;
  right: 0;
  bottom: 0px;
}

.metric_bar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.record_bar .card .card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text-red {
  color: red !important;
}

/*========================================= najam's Style =============================== */
.order_card {
  display: grid;
  grid-template-rows: repeat(2, auto);
  /* border-bottom: 2px solid var(--secondary); */
  /* background: radial-gradient(circle at 100%, #fac430, var(--secondary) 50%, #fff 45%, #fac430 45%); */
  background-color: var(--secondary);
  border-radius: 5px;
  padding-inline: 10px;
  padding-top: 15px;
  box-shadow: 0 0.1rem 0.4rem #00000033;
  transition: 0.5s linear all;
}

.custom-styles {
  /* background: radial-gradient(circle at 70%, #fac430, var(--secondary) 50%, #fac430 100%, #fac430 45%); */
  background-color: #fff;
  /* border: 2px solid #edf9fe; */
}

.custom-styles h1 {
  font-size: calc(14px + (22 - 14) * ((100vw - 320px) / (1920 - 320)));
  /* text-transform: uppercase; */
  /* width: 80%; */
}

.order_card:hover img {
  transform: rotateY(360deg);
  /* Adjust the degree of rotation as needed */
  transition: 0.5s linear all;
  /* Add a smooth transition for the rotation effect */
}

.order_card:hover {
  transform: translateY(-10px);
  transition: 0.5s linear all;
}

.custom-styles .topup {
  font-weight: 500;
  color: #ffff;
  letter-spacing: 1px;
  background-color: #a9d303;
}

.custom-styles .eSim {
  font-weight: 500;
  color: #ffffff;
  letter-spacing: 1px;
  background-color: #039cd3;
}

.custom-styles .issued-to {
  font-weight: 500;
}

.custom-styles hr {
  color: var(--dark);
}

hr {
  margin: 0.5em 0 !important;
}

/* .table-card .card-body {
  background-color: var(--light);
} */
.login_circle {
  width: 200px;
  height: 200px;
  border-radius: 100%;
  background: orangered !important;
  opacity: 0.5;
  right: -2%;
  top: -3%;
}

.pkg-page-card p,
.pkg-page-card h1,
.pkg-page-card h5,
.pkg-page-card small {
  color: white !important;
}

h5 {
  margin-bottom: 0 !important;
}

.pkg-page-card a {
  background-color: white !important;
  color: #212529 !important;
}

.active-unactive-pkg {
  width: 30px !important;
  height: 15px !important;
  /* background-color: red !important; */
  border: white !important;
  cursor: pointer;

  /* --bs-form-switch-bg: url(data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e) !important; */
}

.active-pkg:checked {
  background-color: green !important;
  border: white !important;
}

/* .unactive-pkg:checked {
  background-color: red;
  border: white;
} */
.add-pkg-form > div {
  margin-block: 15px;
}

.add-pkg-form label {
  font-weight: 500;
  margin-bottom: 3px;
}

.add-pkg-form select {
  padding-inline: 10px;
  padding-block: 12px;
}
.add-pkg-form input {
  padding-inline: 10px;
  padding: 12px 45px 12px 12px;
}
select::-ms-expand {
  display: none;
}

.aaa {
  color: #ffd000 !important;
}

.max-Alphabet {
  position: absolute;
  right: 8px;
  margin-block: auto;
  /* height: 100%; */
  font-size: 10px;
}

.max-Alphabet-p {
  position: relative;
  display: flex;
  align-items: center;
}

.type-clr {
  width: 50px;
  padding: 0 !important;
}

.edit-pkg-detail input {
  border: 0;
  width: 100%;
  /* border-bottom: 1px solid #b5aca5; */
  padding: 10px 25px 10px 10px;
  background: #f0ffff !important;
}

.edit-pkg-detail input:focus {
  outline: 0;
}

.pkg-edit-btn {
  position: absolute;
  right: 0;
}

.edit-pkg-detail label {
  font-weight: 500;
  margin-bottom: 10px;
}

.ShowPkgCardImg {
  /* height: 100px; */
  height: calc(40px + (80 - 40) * ((100vw - 320px) / (1920 - 320)));
}

.card-image-p {
  background: #f0ffff !important;
  padding: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.img-bullit li {
  font-size: 10px;
  color: #7b8085;
}

.alert {
  /* min-height: 85vh !important; */
  display: flex !important;
  align-items: center !important;
  flex-direction: column !important;
  justify-content: center !important;
}

@media (min-width: 1200px) {
  .gauge-metrics {
    max-width: 200px;
    position: absolute;
    right: 0;
    bottom: -30px;
  }

  .table-header-item > div {
    margin-inline: 0 !important;
  }

  .main-row {
    grid-template-columns: 300px auto !important;
  }
}

@media (min-width: 992px) {
  .main-row {
    display: grid !important;
    grid-template-columns: 250px auto;
  }

  .offcanva-custome {
    width: 100% !important;
    visibility: visible !important;
    transform: none !important;
    position: relative !important;
  }

  .sidebar-sticky {
    position: sticky !important;
    top: 0 !important;
    height: 100vh;
  }

  .gauge-metrics {
    max-width: 200px;
    position: absolute;
    right: 0;
    bottom: 0px;
  }
}

@media (min-width: 576px) {
  .table-header-item > div {
    width: fit-content;
    /* justify-content: center; */
    /* margin-inline: auto; */
  }
}

@media (max-width: 1200px) {
  .order_history_card ul li {
    font-size: 0.9rem;
    padding-block: 7px;
  }

  .top-chart-bar p {
    margin: 0;
    font-weight: 700;
    font-size: 0.8rem;
  }

  .top-chart-bar span {
    margin: 0;
    font-weight: 600;
    font-size: 0.6rem;
    color: var(--secondary);
  }

  .sidebar ul li a {
    font-size: 0.9rem;
  }
}

@media (max-width: 992px) {
  .heading-m {
    font-size: 15px;
  }

  .heading {
    font-size: 20px;
  }

  .metric_bar .heading-m {
    font-size: 15px;
  }

  .metric_bar .para {
    font-size: 10px;
  }

  .progress-bar-vertical {
    min-height: 115px;
    width: 8px;
    margin-right: 8px;
  }

  .top-chart-bar p {
    margin: 0;
    font-weight: 700;
    font-size: 1rem;
  }

  .top-chart-bar span {
    margin: 0;
    font-weight: 600;
    font-size: 0.8rem;
    color: var(--secondary);
  }
}

@media (max-width: 767px) {
  .login_logo {
    width: 150px;
  }

  button.login_button {
    padding: 0.5em 0em;
  }

  .heading {
    font-size: 25px;
  }

  .table-header-item input,
  .table-header-item select {
    font-size: 12px;
    padding-block: 5px;
  }

  .table-header-item span,
  .table-header-item button {
    font-size: 12px;
  }

  .wrapper {
    padding: 1rem;
  }

  section.login_screen {
    height: 75vh;
    background: none;
  }

  img.bg-img {
    display: none;
  }

  .table-card {
    background-color: transparent !important;
    border-color: transparent !important;
  }

  .table-card .card-body {
    padding: 0;
  }

  .top-chartbar-chart {
    padding-right: 0;
  }

  .mobile-card {
    background-color: transparent !important;
    border: 0 !important;
  }

  .ac_info {
    border: 1px solid #8080804a;
    padding-block: 5px;
  }
}

@media (max-width: 576px) {
  .login_circle {
    top: -5%;
    right: -5%;
  }

  /* .table-header-item div {
    width: 100%;
  } */

  .wrapper {
    padding: 0.7rem;
  }

  .card-body {
    padding: 0.5rem;
  }

  .table-header-item input,
  .table-header-item select {
    font-size: 10px;
  }

  .order-date {
    padding-right: 5px;
  }

  .order_card:nth-child(1) p {
    font-size: 12px;
  }

  /* .order_card img {
    margin-right: 15px;
    width: 50px;
    height: 30px;
  } */
  .order_card img {
    margin-top: -40px !important;
    width: 60px;
    height: 40px;
  }

  .order_card > div:nth-child(2) i::before {
    font-size: 14px;
  }

  .order_card {
    padding-inline: 10px;
  }

  .order_card > div:nth-child(2) {
    margin-top: auto;
  }

  .ac_info input,
  .ac_info p {
    margin-top: 0px;
  }

  .heading {
    font-size: 20px;
    margin: 0;
  }

  .heading-m {
    font-size: 15px;
  }

  .para {
    font-size: 12px;
  }
}

.splash-screen {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  width: 100px;
  color: #fff;
  margin: auto;
  transform: translateY(-50%);
}

.loading span {
  position: absolute;
  height: 10px;
  width: 84px;
  top: 50px;
  overflow: hidden;
}

.loading span > i {
  position: absolute;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  animation: wait 4s infinite;
}

.loading span > i:nth-of-type(1) {
  left: -28px;
  background: yellow;
}

.loading span > i:nth-of-type(2) {
  left: -21px;
  animation-delay: 0.8s;
  background: lightgreen;
}

.img-card-img {
  position: absolute;
  top: 30px;
  right: 10px;
}

@keyframes wait {
  0% {
    left: -7px;
  }

  30% {
    left: 52px;
  }

  60% {
    left: 22px;
  }

  100% {
    left: 100px;
  }
}

.relative-card {
  position: relative;
}

.img-relative {
  position: absolute;
  right: 15px;
  top: 27px;
}

@media (max-width: 400px) {
  .tabCount {
    font-size: 0.7rem !important;
  }
}

@media (max-width: 330px) {
  .custom-resize {
    /* flex-wrap: wrap; */
  }
}

@media (min-width: 280px) and (max-width: 768px) {
  .cus-sm {
    /* border-bottom: 0.1px solid gray; */
    /* padding-bottom: 2em; */
    /* margin-bottom: 2em; */
  }

  .para {
    margin-bottom: 0px;
  }

  div.border-bb {
    border-bottom: 1px solid black !important;
    padding-bottom: 3em;
  }
}

@media (min-width: 768px) {
  button.btn-promo {
    height: 66% !important;
  }
}

.select-cus {
  padding: 1em;
}

.search-cus {
  margin-top: 20px !important;
  padding: 1em;
}

.btn-clear {
  margin-top: 24px !important;
}

.label-cus {
  color: #818181;
}

.mt-24 {
  margin-right: 24px !important;
}

.img-on-small {
  width: 100%;
}

.w-cus {
  width: 70% !important;
}

.w-cus-2 {
  width: 30% !important;
}

.esim-img {
  width: 15% !important;
}

.esim-col-1 {
  width: 80%;
}

.img-history {
  width: 15% !important;
  height: 15% !important;
}

.data-history {
  width: 80%;
}

.d-m {
  width: 400px !important;
}

.dm-inner-sm {
  font-size: 16px;
}

@media (max-width: 320px) {
  .d-m {
    width: 200px !important;
  }
}

@media (max-width: 320px) {
}

@media (max-width: 576px) {
  .w-cus-2 {
    width: 100% !important;
  }
  .w-cus {
    width: 100% !important;
  }
  .esim-col-1 button {
    font-size: 12px;
  }
  .esim-col-1 h1 {
    font-size: 12px !important;
  }

  .esim-col-2 h1 {
    font-size: 10px !important;
  }

  .esim-col-2 p {
    font-size: 10px !important;
  }
}
@media (max-width: 500px) {
  .cus-sidebar-sm {
    width: 100% !important;
  }

  .esim-img {
    width: 100% !important;
  }
  .d-m {
    width: 280px !important;
  }
  .dm-inner-sm {
    font-size: 14px !important;
  }
}
.flag-img-new {
  width: 35px;
  height: 55%;
  filter: drop-shadow(0px 0px 7px #1e1e1e6b);
}
.small-screen {
  width: 50%;
}
.esim-img {
  width: 35px !important;
  height: 65%;
}

.dropdown-item:hover {
  background-color: transparent !important;
  color: #000 !important;
}

@media (max-width: 590px) {
  .small-screen {
    width: 100% !important;
  }
  .container-sm-flex {
    flex-direction: column;
  }
}
.esim_flag img {
  width: 50px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.bg-warning-opacity {
  background-color: rgba(221, 171, 21, 0.5);
}

.bg-success-opacity {
  background-color: rgba(18, 218, 65, 0.5);
}

.bg-danger-opacity {
  background-color: rgba(223, 25, 45, 0.5);
}

.bg-secondary-opacity {
  background-color: rgba(22, 125, 214, 0.5);
}

.bg-info-opacity {
  background-color: rgba(24, 190, 216, 0.5);
}
.badge {
  border-top-right-radius: 5px !important;
  border-top-left-radius: 5px !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.badge2 {
  background-color: red !important;
  color: white !important;
  padding: 4px 8px !important;
  text-align: center !important;
  border-radius: 5px !important;
}
@media screen and (max-width: 679px) {
  .filter-dropdown {
    left: 0px !important;
  }
}

/* .table-container {
  max-height: 400px;
  overflow-y: auto;
}

.table {
  table-layout: fixed;
  width: 100%;
}

thead th {
  position: sticky;
  top: 0;
  background-color: white;
}

tbody td {
  word-wrap: break-word;
} */

/* Custom Checkbox Style */
.custom-checkbox .form-check-input:checked {
  background-color: #f57c21 !important; /* Custom orange color */
  border-color: #f57c21 !important;
}

.custom-checkbox .form-check-input:focus {
  border-color: #f57c21 !important; /* Focused state border color */
}

.custom-checkbox .form-check-input {
  border-radius: 0.25rem !important; /* Optional: To make the checkboxes rounded */
  width: 20px !important; /* Adjust the size */
  height: 20px !important; /* Adjust the size */
}

.custom-checkbox .form-check-label {
  color: #333 !important; /* Label color */
}
`, "",{"version":3,"sources":["webpack://./src/css/styles.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kBAAkB;;AAElB,iBAAiB;;AAEjB;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;EAC5C,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,2BAA2B;EAC3B,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,MAAM;EACN,OAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,2DAA2D;AAC7D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,iEAAiE;;AAEjE;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,oBAAoB;;AAEpB;EACE,kCAAkC;EAClC,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;;GAEG;;AAEH;;;;GAIG;;AAEH,gBAAgB;;AAEhB,0CAA0C;;AAE1C,0CAA0C;;AAE1C;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kEAAkE;AACpE;;AAEA,mBAAmB;;AAEnB;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,6BAA6B;EAC7B,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,+EAA+E;EAC/E;;;;GAIC;EACD,4CAA4C;;EAE5C,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;;;;;;;GAQG;AACH;EACE,8BAA8B;EAC9B,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;;GAOG;AACH;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;;;GAQG;AACH;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,+EAA+E;EAC/E;;;;GAIC;AACH;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,SAAS;EAGT,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2FAA2F;AAC3F;EACE,aAAa;EACb,mCAAmC;EACnC,+CAA+C;EAC/C,uGAAuG;EACvG,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,0GAA0G;EAC1G,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,oEAAoE;EACpE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;EAC5C,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;GAEG;AACH;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,UAAU;EACV,QAAQ;AACV;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,sCAAsC;EACtC,wBAAwB;EACxB,eAAe;;EAEf,yLAAyL;AAC3L;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;;;GAGG;AACH;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,sCAAsC;EACtC,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iEAAiE;AACnE;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wCAAwC;IACxC,oCAAoC;EACtC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wCAAwC;IACxC,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;EACZ;;EAEA;;KAEG;;EAEH;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;KAIG;EACH;IACE,4BAA4B;IAC5B,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY;EAIZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kBAAkB;EAIlB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EAEX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAwDA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yCAAyC;IACzC,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;AACA;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,WAAW;EACX,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,uCAAuC;EACvC,sCAAsC;EACtC,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;;;;;;;;;;;;;;;;;;GAkBG;;AAEH,0BAA0B;AAC1B;EACE,oCAAoC,EAAE,wBAAwB;EAC9D,gCAAgC;AAClC;;AAEA;EACE,gCAAgC,EAAE,+BAA+B;AACnE;;AAEA;EACE,iCAAiC,EAAE,6CAA6C;EAChF,sBAAsB,EAAE,oBAAoB;EAC5C,uBAAuB,EAAE,oBAAoB;AAC/C;;AAEA;EACE,sBAAsB,EAAE,gBAAgB;AAC1C","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap\");\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n  color: #272626;\n  font-family: poppins !important;\n}\n\n:root {\n  --primary: #edf9fe;\n  --secondary: #f57c21;\n  --tertiary: #efd623;\n  --outline: #e4e6ea;\n  --light: #f8f8f8;\n  --dark: #62666b;\n}\n\n/**** Resets *****/\n\n/** login Form **/\n\nbody {\n  width: 100%;\n  height: 100%;\n  font-family: Poppins, sans-serif !important;\n}\n\n.back-secondary {\n  background-color: var(--secondary) !important;\n}\n\n::-webkit-scrollbar {\n  width: 7px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--dark);\n  border-radius: 10px;\n}\n\n.edit-btn-modal {\n  border: 1px solid var(--secondary) !important;\n  margin-inline: 10px;\n  transition: 0.4s !important;\n  margin: 0;\n  padding-block: 2px !important;\n  color: var(--secondary) !important;\n  padding-inline: 20px !important;\n}\n\n.edit-btn-modal:hover {\n  border: 1px solid var(--tertiary) !important;\n  color: var(--tertiary) !important;\n}\n\n.card-btn {\n  background-color: #212529 !important;\n  margin-inline: 10px;\n  transition: 0.4s !important;\n  margin: 0;\n  color: white !important;\n}\n\n.card-btn:hover {\n  scale: 1.02;\n  transition: 0.4s;\n}\n\n.primary-btn {\n  background-color: var(--secondary) !important;\n  margin-inline: 10px;\n  transition: 0.4s !important;\n  margin: 0;\n  color: white !important;\n}\n\n.text-small {\n  font-size: 12px !important;\n}\n\n.clr-secondary {\n  color: var(--secondary) !important;\n}\n\n.primary-btn:hover {\n  background-color: var(--tertiary) !important;\n  scale: 1.02;\n  color: #4a4a4a !important;\n  transition: 0.4s;\n}\n\n.img404 {\n  width: 200px;\n  margin-block: 50px;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.dark-btn {\n  background-color: var(--dark) !important;\n  margin-right: 10px !important;\n  transition: 0.4s !important;\n  margin: 0;\n  color: var(--light) !important;\n  font-size: 12px !important;\n}\n\n.dark-btn:hover {\n  background-color: var(--dark) !important;\n  scale: 1.02;\n  transition: 0.4s;\n}\n\n.chart-btn {\n  background-color: transparent;\n  border: 0;\n  color: #656a72 !important;\n  font-size: 12px !important;\n  margin-right: 10px;\n}\n\n.parent-loader {\n  position: relative;\n  min-height: 100px;\n}\n\n.parent-loader-label {\n  position: relative;\n  width: 12px;\n  height: 12px;\n  display: inline-block;\n}\n\n.parent-loader-label .spinner-border {\n  font-size: 10px;\n  width: 100%;\n  height: 100%;\n}\n\n.parent-loader-btn .loading {\n  background-color: transparent;\n}\n\n.parent-loader-btn {\n  position: relative;\n  width: 12px;\n  height: 12px;\n  display: inline-block;\n}\n\n.parent-loader-btn .spinner-border {\n  font-size: 10px;\n  width: 100%;\n  height: 100%;\n  color: white;\n}\n\n.table-parant-loader {\n  position: relative;\n  height: 100px !important;\n}\n\n.loading {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  top: 0;\n  left: 0;\n  justify-content: center;\n  align-items: center;\n  z-index: 999999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\ninput.login_input {\n  display: block;\n  width: 100%;\n  padding: 1.3em 2em;\n  font-size: 14px;\n  background-color: #eee;\n  border: 0px solid transparent;\n  border-radius: 12px;\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n\nbutton.login_button {\n  display: block;\n  width: 100%;\n  border: 0px solid transparent;\n  background-color: rgb(255, 61, 61);\n  color: #fff;\n  padding: 1.5em 0em;\n  border-radius: 12px !important;\n  font-weight: 600;\n  margin-bottom: 2em;\n  cursor: pointer;\n}\n\nbutton.login_button:hover {\n  background-color: rgba(255, 61, 61, 0.804);\n}\n\n.input {\n  margin-bottom: 2em;\n  position: relative;\n}\n\n.eye_icon {\n  position: absolute;\n  top: 40%;\n  right: 2%;\n}\n\n.eye_icon:hover {\n  cursor: pointer;\n}\n\n.login_screen label {\n  font-size: 0.9rem;\n}\n\nsection.login_screen {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: linear-gradient(90deg, #000000e0 50%, #fff 50%);\n}\n\ndiv.bg_img {\n  width: 100%;\n}\n\nh6.registration {\n  margin-top: 1.5em;\n}\n\nspan.not_registered {\n  color: orangered;\n}\n\nimg.bg-img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 50%;\n  height: 100%;\n  z-index: 10;\n  object-fit: cover;\n}\n\n.missing_field {\n  padding: 0.5em 0;\n  font-size: 12px;\n  color: red;\n}\n\na.forget_link {\n  text-decoration: none;\n  color: #000;\n  font-size: 1rem;\n  font-weight: 400;\n}\n\n/*********************** Sidebar Styles  ************************/\n\ndiv.avatar_wrapper {\n  position: relative !important;\n}\n\n.avatar_img {\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n}\n\n.avatar_status {\n  border-radius: 50%;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  right: 0;\n  background-color: green;\n}\n\na.side_bar_link {\n  text-decoration: none;\n  color: #000 !important;\n  padding-left: 1.5em;\n}\n\n/***** header ******/\n\n.header {\n  background-color: var(--secondary);\n  padding-block: 10px;\n  padding-inline: 20px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.header a {\n  color: white;\n  text-decoration: none;\n  margin-block: auto;\n  font-size: 1rem;\n}\n\n/* Order table css */\n/* p {\n  margin-bottom: 0 !important;\n} */\n\n/* @media (min-width: 348px) and (max-width: 768px) {\n    .header {\n        flex: 1;\n    }\n} */\n\n/** utilities **/\n\n/* Media query to prevent table overflow */\n\n/* Media query to prevent table overflow */\n\n.table_section {\n  width: 100% !important;\n  height: auto !important;\n  padding-left: 18%;\n}\n\n.top-chart-bar > div > div {\n  margin-block: auto;\n}\n\n.top-chart-bar p {\n  margin: 0;\n  font-weight: 700;\n  font-size: 1rem;\n}\n\n.top-chart-bar span {\n  margin: 0;\n  font-weight: 600;\n  font-size: 1rem;\n  color: var(--secondary);\n}\n\n.top-chartbar-chart {\n  padding-inline: 20px;\n  margin-block: auto;\n  width: 100%;\n}\n\n.heading {\n  font-size: 25px;\n  color: #4a4a4a;\n  font-weight: 500;\n}\n\n.heading-m {\n  font-size: 20px;\n  font-weight: 500;\n  color: #4a4a4a;\n}\n\n.wrapper {\n  flex: 1 0 auto;\n  padding: 1.5rem;\n}\n\n.show-canvas {\n  display: block;\n  width: 300px;\n  position: absolute;\n  background-color: #fff;\n  transition: width 0.5s linear all;\n}\n\n.off-canvas {\n  display: block;\n  z-index: 10;\n  /* transition: width 0.5s ease-in-out, opacity 0.5s ease-in-out; */\n}\n\n/***** Order  *****/\n\nul.nav li.nav-item a {\n  color: #585858;\n}\n\n.entries {\n  font-size: 14px;\n}\n\n.table_section {\n  height: 90vh;\n  width: 100%;\n}\n\n.table_overflow {\n  border-collapse: collapse;\n  max-width: 100%;\n  white-space: nowrap;\n  width: 100%;\n}\n\n.custome-table {\n  width: max-content !important;\n  min-width: 100%;\n}\n\ntable td:hover {\n  background-color: #eeee;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\ntable.table-tb th.tr-tt {\n  background-color: #e9eef9 !important;\n}\ntable.table-tb th {\n  background-color: #fff !important;\n}\n\ntable.table-tb td {\n  /* background-color: #fff !important; */\n  border-right: none;\n}\n\ntable th {\n  background-color: #ccc !important;\n  color: #000 !important;\n  font-size: 14px;\n  text-transform: capitalize;\n  font-weight: 300;\n}\n\ntable td {\n  font-size: 15px;\n  border-right: 1px solid #62666b3d;\n  padding-right: 50px !important;\n}\n\n.results {\n  font-weight: 500;\n}\n\n.order_input {\n  padding: 0.3em 0.5em;\n  border: 1px solid #8080804a;\n  font-size: 14px;\n}\n\n.order-wrapper {\n  width: 50%;\n}\n\nth.narrow-col {\n  width: 100px;\n}\n\n.table_more {\n  width: 20px;\n}\n\n.pagination button {\n  background-color: #fff;\n  color: rgb(0, 0, 0) !important;\n  border: 0;\n  margin-inline: 5px;\n  /* padding-inline: 5px; */\n  width: 30px;\n  text-align: center;\n  padding-block: 3px;\n}\n\n.pagination button i {\n  color: rgb(255, 255, 255) !important;\n}\n\n.page-item button {\n  background-color: var(--secondary) !important;\n}\n\n.page-active button {\n  background-color: var(--secondary) !important;\n  color: #fff !important;\n}\n\n.page-active-btn button {\n  background-color: var(--tertiary);\n  color: #4a4a4a;\n}\n\n.para {\n  font-size: 14px;\n}\n\n.para-m {\n  font-size: 12px;\n}\n\n.progress-h {\n  height: 8px !important;\n  --bs-progress-height: 8px !important;\n}\n\n@media (min-width: 320px) and (max-width: 768px) {\n  .order-wrapper {\n    width: 100%;\n  }\n\n  .inputs_wrapper {\n    flex-direction: column;\n  }\n}\n\nli:has(.active_link.active) {\n  background-color: var(--secondary) !important;\n}\n\n.active_link.active {\n  color: white;\n}\n\n.main-content {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.logo {\n  width: 100%;\n  margin-inline: auto;\n}\n\n.login_logo {\n  width: 200px;\n}\n\n.sidebar ul li {\n  list-style: none;\n  margin-block: 7px;\n  padding-inline: 20px;\n  transition: 0.3s;\n}\n\n.sidebar ul li:hover {\n  background-color: var(--secondary);\n  transition: 0.3s;\n}\n\n.sidebar ul li:hover a {\n  color: white !important;\n  transition: 0.3s;\n}\n\n.sidebar ul li a {\n  color: #4a4a4a;\n  text-decoration: none;\n  display: inline-block;\n  width: 100%;\n  background-color: transparent;\n  border: 0;\n  text-align: start;\n  font-size: 1.1rem;\n  width: 100%;\n  padding-block: 12px;\n}\n\n.sidebar ul {\n  padding: 0;\n}\n\n.offcanva-custome {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  border: 0 !important;\n}\n\n.footer {\n  background-color: white;\n  padding-block: 15px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.card {\n  border-radius: 5px !important;\n  border: 1px solid #62666b1f !important;\n}\n\n.card-2 {\n  box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.15);\n}\n\n.order-date {\n  padding-right: 1rem;\n  display: flex;\n  margin-block: 5px;\n  justify-content: end;\n  align-items: center;\n}\n\n.table-header-item {\n  align-items: center;\n  justify-content: space-between;\n}\n\n.table-header-item > div {\n  width: fit-content;\n  /* justify-content: center; */\n}\n\n.table-action-dd {\n  list-style: none;\n  font-weight: 800;\n}\n\n.table-action-dd .dropdown-toggle::after {\n  content: none !important;\n}\n\n.user_info {\n  border-bottom: 2px solid #62666b1f !important;\n  padding-block: 5px;\n}\n\n.user_info p {\n  color: #000;\n  font-size: 1.1rem;\n  /* margin-top: 5px; */\n  margin-bottom: 0;\n}\n\n.user_info label {\n  font-weight: 500;\n  font-size: 0.9rem;\n  color: #62666b;\n}\n\n.coverage_info {\n  border-bottom: 2px solid white !important;\n  padding-block: 15px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.coverage_info p {\n  color: #000;\n  font-size: 1.1rem;\n  /* margin-top: 5px; */\n  margin-bottom: 0;\n}\n\n.coverage_info label {\n  font-weight: 500;\n  font-size: 0.9rem;\n  color: #62666b;\n}\n\n.coverage_info_img {\n  position: absolute;\n  top: -40px;\n  width: 120px;\n  right: 10px;\n}\n\n.coverage_info_img-2 {\n  position: absolute;\n  top: -40px;\n  width: 80px;\n  right: 10px;\n}\n\n.mt-10 {\n  margin-top: 6rem !important;\n}\n\n.ac_info {\n  margin-block: 15px;\n  background-color: var(--light);\n  padding: 10px;\n  border-radius: 10px !important;\n  position: relative;\n}\n\n.ac_info label {\n  font-weight: 200;\n  font-size: 10px;\n}\n\n.ac_info input,\n.ac_info p {\n  background: transparent;\n  padding: 0;\n  font-weight: 500;\n  border: 0;\n  font-size: 14px;\n  width: 100%;\n  margin-top: 5px;\n  margin-bottom: 0;\n}\n\n.ac_info input:focus {\n  border: 0;\n  outline: 0;\n}\n\n.ac_info i {\n  position: absolute;\n  right: 14px;\n  top: 16px;\n}\n\n.v-border {\n  border: 1px solid #62666b1f;\n  width: 1px !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.order_history_card {\n  position: relative;\n  border-radius: 5px !important;\n  /* background: linear-gradient(90deg, rgb(15, 27, 63) 0px, rgb(25, 66, 129)); */\n  background: linear-gradient(\n    90deg,\n    rgb(245 124 33) 0px,\n    rgb(243 135 53 / 68%)\n  );\n  box-shadow: 0 10px 7px 0 rgba(0, 0, 0, 0.15);\n\n  border: 0 !important;\n}\n\n.order_history_card li b,\n.order_history_card li span {\n  color: white;\n}\n\n.order_history_card ul {\n  padding: 0;\n  margin: 0;\n  /* margin-top: 20px; */\n}\n\n.order_history_card ul li {\n  font-size: 1.1rem;\n  display: grid;\n  grid-template-columns: repeat(2, 50%);\n  padding-block: 10px;\n}\n\n.order_history_card ul li b {\n  font-size: 12px;\n}\n\n.order_history_card ul li span {\n  /* color: var(--dark); */\n  text-transform: capitalize;\n  font-size: 12px;\n}\n\n/* .order_history_card::after {\n  border-radius: 20px 20px 0 0px;\n  content: \"\";\n  top: -2;\n  position: absolute;\n  height: 15px;\n  width: 100%;\n  background-color: var(--secondary);\n} */\n.top-line::after {\n  border-radius: 20px 20px 0 0px;\n  content: \"\";\n  top: -2;\n  position: absolute;\n  height: 15px;\n  width: 100%;\n  background-color: var(--secondary);\n}\n\n.table-responsive {\n  min-height: 200px;\n}\n\n.order_card .order_card_date {\n  color: #a3a7ad;\n  margin-top: 10px;\n}\n\n/* .order_card img {\n  width: 80px;\n  height: 50px;\n  box-shadow: 0 0.3rem 0.3rem #00000057;\n  object-fit: fill;\n  margin-block: 10px;\n  margin-right: 20px;\n} */\n.order_card img {\n  width: 80px;\n  height: 50px;\n  box-shadow: 0 0.3rem 0.3rem #00000057;\n  object-fit: fill;\n  margin-top: -55px !important;\n  margin-block: 10px;\n  /* margin-right: 20px; */\n}\n\n.order_card img.verified {\n  margin: 0 !important;\n}\n\n.order_card:hover img.verified {\n  transform: rotate(0);\n}\n\n.order_card_parent > :nth-child(o) {\n  background-color: #000;\n}\n\n/* .order_card {\n  display: grid;\n  grid-template-columns: repeat(2, auto);\n  border-bottom: 2px solid var(--secondary);\n  background-color: var(--light);\n  border-radius: 5px;\n  padding-inline: 15px;\n  box-shadow: 0 0.1rem 0.4rem #00000033;\n} */\n.order_card:nth-child(1) p {\n  margin-bottom: 5px;\n  font-size: 14px;\n  text-transform: capitalize;\n}\n\n.order_card div {\n  /* margin-top: 5px; */\n}\n\n.order_card > div:nth-child(2) {\n  text-align: right;\n  margin-block: auto;\n  font-weight: 500;\n}\n\n.order_card > div:nth-child(2) i::before {\n  font-weight: 600 !important;\n  font-size: 20px;\n  margin-left: 10px;\n}\n\n.order_card > div:nth-child(2) small {\n  font-size: 14px;\n  color: var(--dark);\n}\n\n.slide-left {\n  width: 0 !important;\n}\n\n.slide-left-active {\n  transition: 2s !important;\n  width: 100% !important;\n}\n\n.pkg-card {\n  border: 0 !important;\n  /* background: linear-gradient(90deg, rgb(15, 27, 63) 0px, rgb(25, 66, 129)); */\n  background: linear-gradient(\n    90deg,\n    rgb(245 124 33) 0px,\n    rgb(243 135 53 / 68%)\n  );\n}\n\n.pkg-card p,\n.pkg-card label {\n  color: white;\n}\n\n.pkgslider div {\n  height: 100%;\n}\n\n.min-vp-80 {\n  min-height: 80%;\n}\n\n.trafficsource_chart {\n  position: relative;\n}\n\n.trafficsource_chart::after {\n  width: 64%;\n  height: 64%;\n  content: \"\";\n  background-color: transparent;\n  position: absolute;\n  top: 18%;\n  left: 18%;\n  border-radius: 100%;\n  border: 2px solid #e5e5e5;\n}\n\n.revenuechart {\n  margin-top: 38%;\n}\n\n.w-fit-content {\n  width: fit-content;\n}\n\n.metrics-bar-chart {\n  text-align: end;\n}\n\n.progress-bar-vertical {\n  width: 12px;\n  min-height: 140px;\n  margin-right: 8px;\n  background: #d0cece;\n  display: -webkit-flex;\n  display: inline-block !important;\n  align-items: flex-end;\n  -webkit-align-items: flex-end;\n  transform: rotate(180deg);\n}\n\n.progress-bar-vertical .progress-bar {\n  width: 100%;\n  height: 0;\n  -webkit-transition: height 0.6s ease;\n  -o-transition: height 0.6s ease;\n  transition: height 0.6s ease;\n  background-color: var(--secondary);\n}\n\n.gauge-metrics {\n  max-width: 150px;\n  position: absolute;\n  right: 0;\n  bottom: 0px;\n}\n\n.metric_bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.record_bar .card .card-body {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.text-red {\n  color: red !important;\n}\n\n/*========================================= najam's Style =============================== */\n.order_card {\n  display: grid;\n  grid-template-rows: repeat(2, auto);\n  /* border-bottom: 2px solid var(--secondary); */\n  /* background: radial-gradient(circle at 100%, #fac430, var(--secondary) 50%, #fff 45%, #fac430 45%); */\n  background-color: var(--secondary);\n  border-radius: 5px;\n  padding-inline: 10px;\n  padding-top: 15px;\n  box-shadow: 0 0.1rem 0.4rem #00000033;\n  transition: 0.5s linear all;\n}\n\n.custom-styles {\n  /* background: radial-gradient(circle at 70%, #fac430, var(--secondary) 50%, #fac430 100%, #fac430 45%); */\n  background-color: #fff;\n  /* border: 2px solid #edf9fe; */\n}\n\n.custom-styles h1 {\n  font-size: calc(14px + (22 - 14) * ((100vw - 320px) / (1920 - 320)));\n  /* text-transform: uppercase; */\n  /* width: 80%; */\n}\n\n.order_card:hover img {\n  transform: rotateY(360deg);\n  /* Adjust the degree of rotation as needed */\n  transition: 0.5s linear all;\n  /* Add a smooth transition for the rotation effect */\n}\n\n.order_card:hover {\n  transform: translateY(-10px);\n  transition: 0.5s linear all;\n}\n\n.custom-styles .topup {\n  font-weight: 500;\n  color: #ffff;\n  letter-spacing: 1px;\n  background-color: #a9d303;\n}\n\n.custom-styles .eSim {\n  font-weight: 500;\n  color: #ffffff;\n  letter-spacing: 1px;\n  background-color: #039cd3;\n}\n\n.custom-styles .issued-to {\n  font-weight: 500;\n}\n\n.custom-styles hr {\n  color: var(--dark);\n}\n\nhr {\n  margin: 0.5em 0 !important;\n}\n\n/* .table-card .card-body {\n  background-color: var(--light);\n} */\n.login_circle {\n  width: 200px;\n  height: 200px;\n  border-radius: 100%;\n  background: orangered !important;\n  opacity: 0.5;\n  right: -2%;\n  top: -3%;\n}\n\n.pkg-page-card p,\n.pkg-page-card h1,\n.pkg-page-card h5,\n.pkg-page-card small {\n  color: white !important;\n}\n\nh5 {\n  margin-bottom: 0 !important;\n}\n\n.pkg-page-card a {\n  background-color: white !important;\n  color: #212529 !important;\n}\n\n.active-unactive-pkg {\n  width: 30px !important;\n  height: 15px !important;\n  /* background-color: red !important; */\n  border: white !important;\n  cursor: pointer;\n\n  /* --bs-form-switch-bg: url(data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e) !important; */\n}\n\n.active-pkg:checked {\n  background-color: green !important;\n  border: white !important;\n}\n\n/* .unactive-pkg:checked {\n  background-color: red;\n  border: white;\n} */\n.add-pkg-form > div {\n  margin-block: 15px;\n}\n\n.add-pkg-form label {\n  font-weight: 500;\n  margin-bottom: 3px;\n}\n\n.add-pkg-form select {\n  padding-inline: 10px;\n  padding-block: 12px;\n}\n.add-pkg-form input {\n  padding-inline: 10px;\n  padding: 12px 45px 12px 12px;\n}\nselect::-ms-expand {\n  display: none;\n}\n\n.aaa {\n  color: #ffd000 !important;\n}\n\n.max-Alphabet {\n  position: absolute;\n  right: 8px;\n  margin-block: auto;\n  /* height: 100%; */\n  font-size: 10px;\n}\n\n.max-Alphabet-p {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.type-clr {\n  width: 50px;\n  padding: 0 !important;\n}\n\n.edit-pkg-detail input {\n  border: 0;\n  width: 100%;\n  /* border-bottom: 1px solid #b5aca5; */\n  padding: 10px 25px 10px 10px;\n  background: #f0ffff !important;\n}\n\n.edit-pkg-detail input:focus {\n  outline: 0;\n}\n\n.pkg-edit-btn {\n  position: absolute;\n  right: 0;\n}\n\n.edit-pkg-detail label {\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.ShowPkgCardImg {\n  /* height: 100px; */\n  height: calc(40px + (80 - 40) * ((100vw - 320px) / (1920 - 320)));\n}\n\n.card-image-p {\n  background: #f0ffff !important;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.img-bullit li {\n  font-size: 10px;\n  color: #7b8085;\n}\n\n.alert {\n  /* min-height: 85vh !important; */\n  display: flex !important;\n  align-items: center !important;\n  flex-direction: column !important;\n  justify-content: center !important;\n}\n\n@media (min-width: 1200px) {\n  .gauge-metrics {\n    max-width: 200px;\n    position: absolute;\n    right: 0;\n    bottom: -30px;\n  }\n\n  .table-header-item > div {\n    margin-inline: 0 !important;\n  }\n\n  .main-row {\n    grid-template-columns: 300px auto !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .main-row {\n    display: grid !important;\n    grid-template-columns: 250px auto;\n  }\n\n  .offcanva-custome {\n    width: 100% !important;\n    visibility: visible !important;\n    transform: none !important;\n    position: relative !important;\n  }\n\n  .sidebar-sticky {\n    position: sticky !important;\n    top: 0 !important;\n    height: 100vh;\n  }\n\n  .gauge-metrics {\n    max-width: 200px;\n    position: absolute;\n    right: 0;\n    bottom: 0px;\n  }\n}\n\n@media (min-width: 576px) {\n  .table-header-item > div {\n    width: fit-content;\n    /* justify-content: center; */\n    /* margin-inline: auto; */\n  }\n}\n\n@media (max-width: 1200px) {\n  .order_history_card ul li {\n    font-size: 0.9rem;\n    padding-block: 7px;\n  }\n\n  .top-chart-bar p {\n    margin: 0;\n    font-weight: 700;\n    font-size: 0.8rem;\n  }\n\n  .top-chart-bar span {\n    margin: 0;\n    font-weight: 600;\n    font-size: 0.6rem;\n    color: var(--secondary);\n  }\n\n  .sidebar ul li a {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 992px) {\n  .heading-m {\n    font-size: 15px;\n  }\n\n  .heading {\n    font-size: 20px;\n  }\n\n  .metric_bar .heading-m {\n    font-size: 15px;\n  }\n\n  .metric_bar .para {\n    font-size: 10px;\n  }\n\n  .progress-bar-vertical {\n    min-height: 115px;\n    width: 8px;\n    margin-right: 8px;\n  }\n\n  .top-chart-bar p {\n    margin: 0;\n    font-weight: 700;\n    font-size: 1rem;\n  }\n\n  .top-chart-bar span {\n    margin: 0;\n    font-weight: 600;\n    font-size: 0.8rem;\n    color: var(--secondary);\n  }\n}\n\n@media (max-width: 767px) {\n  .login_logo {\n    width: 150px;\n  }\n\n  button.login_button {\n    padding: 0.5em 0em;\n  }\n\n  .heading {\n    font-size: 25px;\n  }\n\n  .table-header-item input,\n  .table-header-item select {\n    font-size: 12px;\n    padding-block: 5px;\n  }\n\n  .table-header-item span,\n  .table-header-item button {\n    font-size: 12px;\n  }\n\n  .wrapper {\n    padding: 1rem;\n  }\n\n  section.login_screen {\n    height: 75vh;\n    background: none;\n  }\n\n  img.bg-img {\n    display: none;\n  }\n\n  .table-card {\n    background-color: transparent !important;\n    border-color: transparent !important;\n  }\n\n  .table-card .card-body {\n    padding: 0;\n  }\n\n  .top-chartbar-chart {\n    padding-right: 0;\n  }\n\n  .mobile-card {\n    background-color: transparent !important;\n    border: 0 !important;\n  }\n\n  .ac_info {\n    border: 1px solid #8080804a;\n    padding-block: 5px;\n  }\n}\n\n@media (max-width: 576px) {\n  .login_circle {\n    top: -5%;\n    right: -5%;\n  }\n\n  /* .table-header-item div {\n    width: 100%;\n  } */\n\n  .wrapper {\n    padding: 0.7rem;\n  }\n\n  .card-body {\n    padding: 0.5rem;\n  }\n\n  .table-header-item input,\n  .table-header-item select {\n    font-size: 10px;\n  }\n\n  .order-date {\n    padding-right: 5px;\n  }\n\n  .order_card:nth-child(1) p {\n    font-size: 12px;\n  }\n\n  /* .order_card img {\n    margin-right: 15px;\n    width: 50px;\n    height: 30px;\n  } */\n  .order_card img {\n    margin-top: -40px !important;\n    width: 60px;\n    height: 40px;\n  }\n\n  .order_card > div:nth-child(2) i::before {\n    font-size: 14px;\n  }\n\n  .order_card {\n    padding-inline: 10px;\n  }\n\n  .order_card > div:nth-child(2) {\n    margin-top: auto;\n  }\n\n  .ac_info input,\n  .ac_info p {\n    margin-top: 0px;\n  }\n\n  .heading {\n    font-size: 20px;\n    margin: 0;\n  }\n\n  .heading-m {\n    font-size: 15px;\n  }\n\n  .para {\n    font-size: 12px;\n  }\n}\n\n.splash-screen {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loading {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  width: 100px;\n  color: #fff;\n  margin: auto;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.loading span {\n  position: absolute;\n  height: 10px;\n  width: 84px;\n  top: 50px;\n  overflow: hidden;\n}\n\n.loading span > i {\n  position: absolute;\n  height: 4px;\n  width: 4px;\n  border-radius: 50%;\n  -webkit-animation: wait 4s infinite;\n  -moz-animation: wait 4s infinite;\n  -o-animation: wait 4s infinite;\n  animation: wait 4s infinite;\n}\n\n.loading span > i:nth-of-type(1) {\n  left: -28px;\n  background: yellow;\n}\n\n.loading span > i:nth-of-type(2) {\n  left: -21px;\n  -webkit-animation-delay: 0.8s;\n  animation-delay: 0.8s;\n  background: lightgreen;\n}\n\n.img-card-img {\n  position: absolute;\n  top: 30px;\n  right: 10px;\n}\n\n@-webkit-keyframes wait {\n  0% {\n    left: -7px;\n  }\n\n  30% {\n    left: 52px;\n  }\n\n  60% {\n    left: 22px;\n  }\n\n  100% {\n    left: 100px;\n  }\n}\n\n@-moz-keyframes wait {\n  0% {\n    left: -7px;\n  }\n\n  30% {\n    left: 52px;\n  }\n\n  60% {\n    left: 22px;\n  }\n\n  100% {\n    left: 100px;\n  }\n}\n\n@-o-keyframes wait {\n  0% {\n    left: -7px;\n  }\n\n  30% {\n    left: 52px;\n  }\n\n  60% {\n    left: 22px;\n  }\n\n  100% {\n    left: 100px;\n  }\n}\n\n@keyframes wait {\n  0% {\n    left: -7px;\n  }\n\n  30% {\n    left: 52px;\n  }\n\n  60% {\n    left: 22px;\n  }\n\n  100% {\n    left: 100px;\n  }\n}\n\n.relative-card {\n  position: relative;\n}\n\n.img-relative {\n  position: absolute;\n  right: 15px;\n  top: 27px;\n}\n\n@media (max-width: 400px) {\n  .tabCount {\n    font-size: 0.7rem !important;\n  }\n}\n\n@media (max-width: 330px) {\n  .custom-resize {\n    /* flex-wrap: wrap; */\n  }\n}\n\n@media (min-width: 280px) and (max-width: 768px) {\n  .cus-sm {\n    /* border-bottom: 0.1px solid gray; */\n    /* padding-bottom: 2em; */\n    /* margin-bottom: 2em; */\n  }\n\n  .para {\n    margin-bottom: 0px;\n  }\n\n  div.border-bb {\n    border-bottom: 1px solid black !important;\n    padding-bottom: 3em;\n  }\n}\n\n@media (min-width: 768px) {\n  button.btn-promo {\n    height: 66% !important;\n  }\n}\n\n.select-cus {\n  padding: 1em;\n}\n\n.search-cus {\n  margin-top: 20px !important;\n  padding: 1em;\n}\n\n.btn-clear {\n  margin-top: 24px !important;\n}\n\n.label-cus {\n  color: #818181;\n}\n\n.mt-24 {\n  margin-right: 24px !important;\n}\n\n.img-on-small {\n  width: 100%;\n}\n\n.w-cus {\n  width: 70% !important;\n}\n\n.w-cus-2 {\n  width: 30% !important;\n}\n\n.esim-img {\n  width: 15% !important;\n}\n\n.esim-col-1 {\n  width: 80%;\n}\n\n.img-history {\n  width: 15% !important;\n  height: 15% !important;\n}\n\n.data-history {\n  width: 80%;\n}\n\n.d-m {\n  width: 400px !important;\n}\n\n.dm-inner-sm {\n  font-size: 16px;\n}\n\n@media (max-width: 320px) {\n  .d-m {\n    width: 200px !important;\n  }\n}\n\n@media (max-width: 320px) {\n}\n\n@media (max-width: 576px) {\n  .w-cus-2 {\n    width: 100% !important;\n  }\n  .w-cus {\n    width: 100% !important;\n  }\n  .esim-col-1 button {\n    font-size: 12px;\n  }\n  .esim-col-1 h1 {\n    font-size: 12px !important;\n  }\n\n  .esim-col-2 h1 {\n    font-size: 10px !important;\n  }\n\n  .esim-col-2 p {\n    font-size: 10px !important;\n  }\n}\n@media (max-width: 500px) {\n  .cus-sidebar-sm {\n    width: 100% !important;\n  }\n\n  .esim-img {\n    width: 100% !important;\n  }\n  .d-m {\n    width: 280px !important;\n  }\n  .dm-inner-sm {\n    font-size: 14px !important;\n  }\n}\n.flag-img-new {\n  width: 35px;\n  height: 55%;\n  filter: drop-shadow(0px 0px 7px #1e1e1e6b);\n}\n.small-screen {\n  width: 50%;\n}\n.esim-img {\n  width: 35px !important;\n  height: 65%;\n}\n\n.dropdown-item:hover {\n  background-color: transparent !important;\n  color: #000 !important;\n}\n\n@media (max-width: 590px) {\n  .small-screen {\n    width: 100% !important;\n  }\n  .container-sm-flex {\n    flex-direction: column;\n  }\n}\n.esim_flag img {\n  width: 50px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n}\n\n.bg-warning-opacity {\n  background-color: rgba(221, 171, 21, 0.5);\n}\n\n.bg-success-opacity {\n  background-color: rgba(18, 218, 65, 0.5);\n}\n\n.bg-danger-opacity {\n  background-color: rgba(223, 25, 45, 0.5);\n}\n\n.bg-secondary-opacity {\n  background-color: rgba(22, 125, 214, 0.5);\n}\n\n.bg-info-opacity {\n  background-color: rgba(24, 190, 216, 0.5);\n}\n.badge {\n  border-top-right-radius: 5px !important;\n  border-top-left-radius: 5px !important;\n  border-bottom-right-radius: 0px !important;\n  border-bottom-left-radius: 0px !important;\n}\n.badge2 {\n  background-color: red !important;\n  color: white !important;\n  padding: 4px 8px !important;\n  text-align: center !important;\n  border-radius: 5px !important;\n}\n@media screen and (max-width: 679px) {\n  .filter-dropdown {\n    left: 0px !important;\n  }\n}\n\n/* .table-container {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.table {\n  table-layout: fixed;\n  width: 100%;\n}\n\nthead th {\n  position: sticky;\n  top: 0;\n  background-color: white;\n}\n\ntbody td {\n  word-wrap: break-word;\n} */\n\n/* Custom Checkbox Style */\n.custom-checkbox .form-check-input:checked {\n  background-color: #f57c21 !important; /* Custom orange color */\n  border-color: #f57c21 !important;\n}\n\n.custom-checkbox .form-check-input:focus {\n  border-color: #f57c21 !important; /* Focused state border color */\n}\n\n.custom-checkbox .form-check-input {\n  border-radius: 0.25rem !important; /* Optional: To make the checkboxes rounded */\n  width: 20px !important; /* Adjust the size */\n  height: 20px !important; /* Adjust the size */\n}\n\n.custom-checkbox .form-check-label {\n  color: #333 !important; /* Label color */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
